import { GESTIONES_COMERCIALES, SEGURIDAD } from "./routes";

export const PORTAL_TERMS_ALLOWED_ROUTES = [
  GESTIONES_COMERCIALES,
  SEGURIDAD,
];

export const isPortalTermsRouteAllowed = (pathname: string): boolean => {
  return PORTAL_TERMS_ALLOWED_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
};
